<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<mat-toolbar class="toolbar" [style.backgroundColor]="'var(--crucible-topbar-background)'"
  [style.color]="'var(--crucible-topbar-text)'">
  <mat-toolbar-row>
    <span class="margin-auto">
      <a mat-icon-button style="outline: none; background-color: var(--crucible-topbar-text);" [routerLink]="['/']" title="Home">
        <mat-icon svgIcon="ic_crucible_alloy"></mat-icon>
      </a>
    </span>
    <span class="view-text">{{ title }}</span>
    @if (teams && team && teams.length > 0) {
    <div class="team-text">Team:</div>
    <b class="team-text">{{ team.name }}</b>
    @if (teams.length > 1) {
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-button [matMenuTriggerFor]="teamMenu" style="outline: none">
        <mat-icon class="menu-trigger" svgIcon="ic_expand_more_white_24px"></mat-icon>
      </button>
      <mat-menu #teamMenu="matMenu" [overlapTrigger]="false">
        @for (val of teams; track val) {
        <button mat-menu-item (click)="setTeamFn(val.id)">
          {{ val.name }}
        </button>
        }
      </mat-menu>
    </div>
    }
    }
    <span class="spacer"></span>
    @if (currentUser$ | async; as currentUser) {
    <div class="user-text">
      <button mat-button class="menu-trigger" [matMenuTriggerFor]="menu" style="outline: none"
        [style.color]="'var(--crucible-topbar-text)'">
        <strong>{{ currentUser.name }}</strong>
        <mat-icon aria-hidden="false" class="menu-trigger" fontIcon="mdi-chevron-down"></mat-icon>
      </button>
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        @if (team && team.canManage) {
        <button (click)="editFn($event)" mat-menu-item>
          Edit View
        </button>
        }
        @if (topbarView === TopbarView.ALLOY_ADMIN) {
        <button [routerLink]="['/']" mat-menu-item>
          Exit Administration
        </button>
        }
        @if (topbarView !== TopbarView.ALLOY_ADMIN && canViewAdmin) {
        <button [routerLink]="['/admin']" mat-menu-item>
          Administration
        </button>
        }
        <button mat-menu-item (click)="logout()">Logout</button>
        <mat-slide-toggle class="mat-menu-item" color="primary"
          [checked]="(theme$ | async) === 'dark-theme' ? true : false" (click)="$event.stopPropagation()"
          (change)="themeFn($event)">
          Dark Theme
        </mat-slide-toggle>
      </mat-menu>
    </div>
    }
  </mat-toolbar-row>
</mat-toolbar>
